var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDot = function SvgDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.443 3a5.465 5.465 0 0 0-5.156 7.21.778.778 0 0 0 .957.478.775.775 0 0 0 .463-.954 3.591 3.591 0 0 1-.212-1.388 3.926 3.926 0 1 1 4.163 4.037s-.764.047-1.144.093c-.14.02-.279.048-.416.083a.05.05 0 0 1-.071 0 .05.05 0 0 1 0-.06l.117-.646.718-3.227a.746.746 0 0 0-1.46-.312s-1.706 7.898-1.706 7.97a.717.717 0 0 0 .531.875h.04c.383.1.775-.131.873-.515l.005-.02a.186.186 0 0 1 0-.035c.021-.093.236-1.144.236-1.144a1.936 1.936 0 0 1 1.603-1.524c.165-.025.857-.072.857-.072A5.439 5.439 0 0 0 10.443 3Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.773 15.55a.907.907 0 0 0-1.073.703l-.003.013a.903.903 0 0 0 .692 1.076h.026a.889.889 0 0 0 1.073-.655l.002-.011v-.05a.94.94 0 0 0-.717-1.077Z",
    fill: "#E6007A"
  })));
};
export default SvgDot;